/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Grower_Report_Split_NoteInputs */

const vi_my_grower_report_split_note = /** @type {(inputs: My_Grower_Report_Split_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhật ký ghi nhiều bãi được chia đều lượng cho từng bãi.`)
};

/**

* @param {My_Grower_Report_Split_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_split_note = /** @type {((inputs?: My_Grower_Report_Split_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_Split_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_split_note(inputs)
});